import { useTranslation } from 'react-i18next'
import { Checkbox } from '@/components/shadcn/checkbox'
import { Label } from '@/components/shadcn/label'
import { InAppNotificationActionType } from '@/api/model/inAppNotificationActionType'
import type { InAppNotificationActionRequest } from '@/api/model/inAppNotificationActionRequest'
import { NotificationActionFields } from './NotificationActionFields'

interface Props {
  action: InAppNotificationActionRequest | null
  onChange: (action: InAppNotificationActionRequest | null) => void
  isCompanyWideAssigned: boolean
  groupIds: number[]
  employeeUserIds: string[]
  showError?: boolean
}

export function NotificationLinking({
  action, onChange, isCompanyWideAssigned, groupIds, employeeUserIds, showError,
}: Props) {
  const { t } = useTranslation('notifications')

  return (
    <div className="flex flex-col gap-3">
      <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{t('dialog.linking.title')}</p>
      <div className="flex items-center gap-2">
        <Checkbox
          id="action-enabled"
          checked={action !== null}
          onCheckedChange={(checked) =>
            onChange(
              checked === true
                ? { type: InAppNotificationActionType.ActionModule, actionText: '', reference: undefined }
                : null,
            )
          }
        />
        <Label htmlFor="action-enabled" className="cursor-pointer font-normal text-sm">{t('dialog.linking.enable')}</Label>
      </div>
      {action && (
          <NotificationActionFields
            action={action}
            onChange={onChange}
            isCompanyWideAssigned={isCompanyWideAssigned}
            groupIds={groupIds}
            employeeUserIds={employeeUserIds}
            showError={showError}
          />
      )}
    </div>
  )
}
